interface StreakBadgeProps {
  value: number;
}

export function StreakBadge({ value }: StreakBadgeProps) {
  return (
    <div className="streak-badge" title="Daily streak">
      <span className="dot dot--amber" />
      <span className="t-mono" style={{ fontSize: 12, fontWeight: 500 }}>{value}d</span>
    </div>
  );
}
